import { render } from "./HouseBottomCustomer.vue?vue&type=template&id=670f3641"
import script from "./HouseBottomCustomer.vue?vue&type=script&lang=js"
export * from "./HouseBottomCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__